import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":4003";
};

export const sendMerchantInterestEmail = params => {
  const url = `${baseURL()}/email`;
  return axios.post(url, params);
};
